import React, { Suspense } from 'react';
import { ProductionOrdersPage } from './ProductionOrdersPage';

// Loading component específico para produção
const ProductionLoading = () => (
  <div className="h-full w-full flex flex-col bg-navy-900 min-w-[285px]">
    <div className="p-4 border-b border-navy-800">
      <div className="animate-pulse flex items-center space-x-3">
        <div className="h-8 w-32 bg-navy-800 rounded"></div>
        <div className="h-6 w-24 bg-navy-800 rounded"></div>
      </div>
    </div>
    <div className="flex-1 p-4">
      <div className="animate-pulse space-y-3">
        <div className="h-12 w-full bg-navy-800 rounded"></div>
        <div className="h-8 w-3/4 bg-navy-800 rounded"></div>
        <div className="h-8 w-1/2 bg-navy-800 rounded"></div>
      </div>
    </div>
  </div>
);

// Componente lazy com fallback específico
export const ProductionOrdersPageLazy = React.lazy(() =>
  import('./ProductionOrdersPage').then(module => ({
    default: module.ProductionOrdersPage
  }))
);

// Wrapper com Suspense e fallback específico
export const ProductionOrdersPageWithSuspense: React.FC<{ onBack?: () => void; onNavigateToExport?: () => void }> = ({ onBack, onNavigateToExport }) => (
  <Suspense fallback={<ProductionLoading />}>
    <ProductionOrdersPageLazy onBack={onBack} onNavigateToExport={onNavigateToExport} />
  </Suspense>
);
